import { css } from 'styled-components';

const BORDER_BOX = css`
  box-sizing: border-box;
`;

const DEEP_BORDER_BOX = css`
  box-sizing: border-box;
    * {
      box-sizing: border-box;
    }
`;

export { BORDER_BOX, DEEP_BORDER_BOX };